import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { Container } from '@sm/wds-react';
import { HomeBottomCard } from '../HomeBottomCard';
import audienceImage from '../assets/Audience.png';
import buildingsImage from '../assets/Buildings.png';

const COPY = defineMessages({
  HEADLINE_MARKET_RESEARCH: {
    id: 'EnterpriseCard.headlineMarketResearch',
    defaultMessage: 'Buy responses for your market research surveys',
    description:
      '[Type: Paragraph][Vis.: low] - Home bottom card market research headline',
  },
  MESSAGE_MARKET_RESEARCH: {
    id: 'EnterpriseCard.messageMarketResearch',
    defaultMessage: 'Find people to take your survey at an affordable price.',
    description:
      '[Type: Paragraph][Vis.: low] - Home bottom card market research message',
  },
  CTA_TEXT_MARKET_RESEARCH: {
    id: 'EnterpriseCard.ctaTextMarketResearch',
    defaultMessage: 'See pricing',
    description:
      '[Type: Button][Vis.: low] - Home bottom card market research cta text',
  },
  HEADLINE_ENTERPRISE: {
    id: 'EnterpriseCard.headlineEnterprise',
    defaultMessage: 'Business surveys for your whole organization',
    description:
      '[Type: Paragraph][Vis.: low] - Enterprise card business surveys headline',
  },
  MESSAGE_ENTERPRISE: {
    id: 'EnterpriseCard.messageEnterprise',
    defaultMessage: 'Get advanced security, administration, and collaboration.',
    description:
      '[Type: Paragraph][Vis.: low] - Enterprise card business surveys message',
  },
  CTA_TEXT_ENTERPRISE: {
    id: 'EnterpriseCard.ctaTextEnterprise',
    defaultMessage: 'Learn more',
    description:
      '[Type: Button][Vis.: low] - Enterprise card business surveys cta text',
  },
});

export const EnterpriseCard: React.FC = () => {
  return (
    <Container flex flexJustify="between">
      <HomeBottomCard
        headline={t(COPY.HEADLINE_MARKET_RESEARCH)}
        message={t(COPY.MESSAGE_MARKET_RESEARCH)}
        image={() => (
          <img
            src={audienceImage}
            width={60}
            height="auto"
            aria-hidden="true"
          />
        )}
        ctaText={t(COPY.CTA_TEXT_MARKET_RESEARCH)}
        ctaLink={createURL('/collect/audience/calculator/preview/', {
          ut_source: 'ucs',
          ut_source2: 'li_home',
          ut_source3: 'affordable-market-research-left',
          cvosrc: 'product.surveymonkey',
          cvo_campaign: 'li_home',
        })}
        ctaNewTab={true}
      />
      <HomeBottomCard
        headline={t(COPY.HEADLINE_ENTERPRISE)}
        message={t(COPY.MESSAGE_ENTERPRISE)}
        image={() => (
          <img
            src={buildingsImage}
            width={50}
            height="auto"
            aria-hidden="true"
          />
        )}
        ctaText={t(COPY.CTA_TEXT_ENTERPRISE)}
        ctaLink={createURL(
          '/business/products/enterprise/advanced-survey-features/',
          {
            ut_source: 'ucs',
            ut_source2: 'li_home',
            ut_source3: 'business-surveys-hours-right',
            utm_source: 'surveymonkey',
            utm_medium: 'product',
            utm_content: 'advanced-features',
            utm_term: 'learn-more',
            utm_campaign: 'li_home',
            adid: 'li_home',
            family: 'SME',
            date: '2017-03-19',
            program: '7013A000000tzrhQAA',
            source: 'SurveyMonkey',
            recent: 'SurveyMonkey',
            cvosrc: 'product.surveymonkey',
            cvo_campaign: '7013A000000tzrhQAA',
            cvo_cid: 'li_home',
          }
        )}
        ctaNewTab={true}
      />
    </Container>
  );
};

export default EnterpriseCard;
